import { faQuestionCircle } from '@fortawesome/pro-solid-svg-icons/faQuestionCircle';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormattedMessage } from 'react-intl';

import { Checkbox } from 'ui-components/components/checkbox/';
import { Tooltip } from 'ui-components/components/tooltip';
import { noop } from 'ui-components/default-props/noop';

import style from './inputs.module.less';
import { useBillDutiesAndTaxesToPayor } from '../../../../hooks/use-seller-setting';
import { useShouldShowDdp } from '../../use-should-show-ddp';

/**
 * @param {{label: JSX.Element, checked?: boolean, onCheck?: () => void, fulfillmentPlanId: string, tooltip?: JSX.Element}} props
 * @returns {JSX.Element|null}
 */
const DefaultOrHideOption = ({ label, checked = false, onCheck = noop, fulfillmentPlanId, tooltip = null }) => {
  const shouldShowDdp = useShouldShowDdp(fulfillmentPlanId);
  const DDPSellerSettingsEnabled = useBillDutiesAndTaxesToPayor();

  if (shouldShowDdp) {
    return (
      <div className={style['default-option']}>
        <Checkbox checked={checked} label={label} onChange={onCheck} />
        {tooltip && DDPSellerSettingsEnabled ? (
          <Tooltip text={<FormattedMessage {...tooltip} />}>
            <div className={style['information-icon']}>
              <FontAwesomeIcon icon={faQuestionCircle} />
            </div>
          </Tooltip>
        ) : null}
      </div>
    );
  }
  return null;
};

export default DefaultOrHideOption;
